/* Noyra Wear — Theme JavaScript */

(function() {
  'use strict';

  /* ==================================================================
     TOAST NOTIFICATION
     ================================================================== */
  function showToast(message, duration) {
    var toast = document.querySelector('[data-nw-toast]');
    if (!toast) return;
    duration = duration || 3000;
    toast.innerHTML = '&#10003; ' + message;
    toast.classList.add('is-visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function() {
      toast.classList.remove('is-visible');
    }, duration);
  }

  /* ==================================================================
     CART DRAWER — open / close / refresh
     ================================================================== */
  function openCartDrawer() {
    var drawer = document.querySelector('[data-nw-cart-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('[data-nw-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function refreshCartDrawer() {
    fetch('/?section_id=nw-cart-drawer')
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newDrawer = temp.querySelector('[data-nw-cart-drawer]');
        var oldDrawer = document.querySelector('[data-nw-cart-drawer]');
        if (newDrawer && oldDrawer) {
          var wasOpen = oldDrawer.classList.contains('is-open');
          oldDrawer.innerHTML = newDrawer.innerHTML;
          if (wasOpen) oldDrawer.classList.add('is-open');
          bindCartDrawerEvents();
          initTestimonialRotation();
        }
      });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-nw-cart-count]').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
    document.querySelectorAll('[data-nw-drawer-count]').forEach(function(el) {
      el.textContent = count;
    });
  }

  function bindCartDrawerEvents() {
    var drawer = document.querySelector('[data-nw-cart-drawer]');
    if (!drawer) return;

    drawer.querySelectorAll('[data-nw-cart-close]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        closeCartDrawer();
      });
    });

    drawer.querySelectorAll('[data-nw-qty-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var line = btn.getAttribute('data-line');
        var valEl = btn.parentNode.querySelector('.nw-cart-drawer__qty-val');
        var current = parseInt(valEl.textContent, 10) || 1;
        var newQty = Math.max(0, current - 1);
        updateCartLine(parseInt(line, 10), newQty);
      });
    });

    drawer.querySelectorAll('[data-nw-qty-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var line = btn.getAttribute('data-line');
        var valEl = btn.parentNode.querySelector('.nw-cart-drawer__qty-val');
        var current = parseInt(valEl.textContent, 10) || 1;
        updateCartLine(parseInt(line, 10), current + 1);
      });
    });

    drawer.querySelectorAll('.nw-cart-drawer__item-remove').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var url = new URL(link.href, window.location.origin);
        var line = url.searchParams.get('line');
        if (line) updateCartLine(parseInt(line, 10), 0);
      });
    });
  }

  function updateCartLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      refreshCartDrawer();
    });
  }

  function initCartDrawer() {
    document.querySelectorAll('[data-nw-cart-open]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        openCartDrawer();
      });
    });
    bindCartDrawerEvents();
  }

  /* ==================================================================
     AJAX ADD TO CART
     ================================================================== */
  function initBuyNow() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-nw-buy-now]');
      if (!btn) return;
      var form = btn.closest('form');
      if (!form) return;
      btn.disabled = true;
      btn.textContent = 'Yönlendiriliyor...';
      var data = new FormData(form);
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function() { return fetch('/cart/add.js', { method: 'POST', body: data }); })
        .then(function() { window.location.href = '/checkout'; })
        .catch(function() {
          btn.disabled = false;
          btn.innerHTML = 'Hemen Satın Al →';
        });
    });
  }

  function initAjaxCart() {
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (form.tagName !== 'FORM' || form.action.indexOf('/cart/add') === -1) return;

      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var originalText = btn ? btn.innerHTML : '';
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = 'Ekleniyor...';
      }

      var data = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: data
      })
      .then(function(r) { return r.json(); })
      .then(function(item) {
        var title = item.product_title || item.title || 'Ürün';
        var shortTitle = title.split(' ').slice(-3).join(' ');
        showToast('Sepete eklendi · ' + shortTitle);

        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            updateCartCount(cart.item_count);
            refreshCartDrawer();
          });

        if (btn) {
          btn.innerHTML = '✓ Eklendi!';
          setTimeout(function() {
            btn.disabled = false;
            btn.innerHTML = originalText;
          }, 1500);
        }
      })
      .catch(function() {
        showToast('Sepete eklenemedi. Lütfen tekrar deneyin.');
        if (btn) {
          btn.disabled = false;
          btn.innerHTML = originalText;
        }
      });
    });
  }

  /* ==================================================================
     MOBILE MENU DRAWER
     ================================================================== */
  function initMobileMenu() {
    var menu = document.querySelector('[data-nw-mobile-menu]');
    if (!menu) return;

    document.querySelectorAll('[data-nw-menu-open]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        menu.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    });

    menu.querySelectorAll('[data-nw-menu-close]').forEach(function(el) {
      el.addEventListener('click', function() {
        menu.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ==================================================================
     COUNTDOWN TIMER
     ================================================================== */
  function initCountdown() {
    var el = document.querySelector('[data-nw-countdown]');
    if (!el) return;
    var endDate = el.getAttribute('data-nw-countdown');
    if (!endDate) return;
    var target = new Date(endDate).getTime();

    function tick() {
      var ms = Math.max(0, target - Date.now());
      var d = Math.floor(ms / 86400000);
      var h = Math.floor(ms / 3600000) % 24;
      var m = Math.floor(ms / 60000) % 60;
      var s = Math.floor(ms / 1000) % 60;
      el.textContent =
        String(d).padStart(2, '0') + 'G ' +
        String(h).padStart(2, '0') + ':' +
        String(m).padStart(2, '0') + ':' +
        String(s).padStart(2, '0');
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ==================================================================
     SEARCH TOGGLE
     ================================================================== */
  function initSearchToggle() {
    var btn = document.querySelector('[data-nw-search-toggle]');
    var row = document.querySelector('[data-nw-search-row]');
    if (!btn || !row) return;
    btn.addEventListener('click', function() {
      row.classList.toggle('is-open');
      var input = row.querySelector('input');
      if (input && row.classList.contains('is-open')) input.focus();
    });
  }

  /* ==================================================================
     PDP — Accordions
     ================================================================== */
  function initAccordions() {
    document.querySelectorAll('[data-nw-accordion]').forEach(function(acc) {
      var header = acc.querySelector('[data-nw-accordion-toggle]');
      if (!header) return;
      header.addEventListener('click', function() {
        acc.classList.toggle('is-open');
        var toggle = header.querySelector('.nw-pdp__accordion-toggle');
        if (toggle) toggle.textContent = acc.classList.contains('is-open') ? '−' : '+';
      });
    });
  }

  /* ==================================================================
     PDP — Thumbnail Gallery
     ================================================================== */
  function initGallery() {
    document.querySelectorAll('[data-nw-gallery]').forEach(function(gallery) {
      var thumbs = gallery.querySelectorAll('[data-nw-thumb]');
      var mainImg = gallery.querySelector('[data-nw-main-image]');
      if (!mainImg) return;

      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          thumbs.forEach(function(t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          var src = thumb.getAttribute('data-nw-thumb');
          if (src && mainImg.querySelector('img')) {
            mainImg.querySelector('img').src = src;
          }
        });
      });
    });
  }

  /* ==================================================================
     PDP — Quantity Stepper
     ================================================================== */
  function initQuantity() {
    document.querySelectorAll('[data-nw-qty]').forEach(function(wrapper) {
      if (wrapper.closest('[data-nw-cart-drawer]')) return;
      var input = wrapper.querySelector('input');
      var minus = wrapper.querySelector('[data-nw-qty-minus]');
      var plus = wrapper.querySelector('[data-nw-qty-plus]');
      if (!input) return;

      if (minus) minus.addEventListener('click', function() {
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, v - 1);
        input.dispatchEvent(new Event('change'));
      });

      if (plus) plus.addEventListener('click', function() {
        var v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
        input.dispatchEvent(new Event('change'));
      });
    });
  }

  /* ==================================================================
     PDP — Size Chip Selector
     ================================================================== */
 function initSizeSelector() {
    var dataEl = document.querySelector('[data-nw-variant-data]');
    var groups = document.querySelectorAll('[data-nw-option]');
    if (!dataEl || !groups.length) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var form = document.querySelector('.nw-pdp form[action*="/cart/add"]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceEl = document.querySelector('.nw-pdp__price');
    var compareEl = document.querySelector('.nw-pdp__compare-price');
    var badgeEl = document.querySelector('.nw-pdp__discount-badge');
    var submitBtn = form ? form.querySelector('[type="submit"]') : null;
    var buyNowBtn = document.querySelector('[data-nw-buy-now]');
    var mainImg = document.querySelector('[data-nw-main-image] img');

    function selectedValues() {
      var vals = [];
      groups.forEach(function(group) {
        var active = group.querySelector('[data-nw-option-value].is-active');
        vals.push(active ? active.getAttribute('data-nw-option-value') : null);
      });
      return vals;
    }

    function findVariant(vals) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < vals.length; j++) {
          if (variants[i].options[j] !== vals[j]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }

    function markSoldOut(vals) {
      groups.forEach(function(group, gi) {
        group.querySelectorAll('[data-nw-option-value]').forEach(function(chip) {
          var test = vals.slice();
          test[gi] = chip.getAttribute('data-nw-option-value');
          var v = findVariant(test);
          chip.classList.toggle('is-soldout', !(v && v.available));
        });
      });
    }

    function showVariantImage(src) {
      if (!src || !mainImg) return;
      var loader = new Image();
      loader.onload = function() { mainImg.src = src; };
      loader.src = src;
      document.querySelectorAll('[data-nw-thumb]').forEach(function(t) {
        t.classList.toggle('is-active', t.getAttribute('data-nw-thumb') === src);
      });
    }

    function applyVariant(variant) {
      if (!variant) {
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Bu seçenek mevcut değil'; }
        if (buyNowBtn) buyNowBtn.disabled = true;
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      if (compareEl) {
        compareEl.style.display = variant.compare_at_price ? '' : 'none';
        if (variant.compare_at_price) compareEl.textContent = variant.compare_at_price;
      }
      if (badgeEl) {
        badgeEl.style.display = variant.discount_pct ? '' : 'none';
        if (variant.discount_pct) badgeEl.textContent = '%' + variant.discount_pct + ' İNDİRİM';
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? 'Sepete Ekle · ' + variant.price : 'Tükendi';
      }
      if (buyNowBtn) buyNowBtn.disabled = !variant.available;
      showVariantImage(variant.image);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url.toString());
    }

    groups.forEach(function(group) {
      group.querySelectorAll('[data-nw-option-value]').forEach(function(chip) {
        chip.addEventListener('click', function() {
          group.querySelectorAll('[data-nw-option-value]').forEach(function(c) { c.classList.remove('is-active'); });
          chip.classList.add('is-active');
          var label = group.querySelector('[data-nw-option-selected]');
          if (label) label.textContent = chip.getAttribute('data-nw-option-value');
          var vals = selectedValues();
          applyVariant(findVariant(vals));
          markSoldOut(vals);
        });
      });
    });

    markSoldOut(selectedValues());
  }

  /* ==================================================================
     REVIEW CAROUSEL
     ================================================================== */
  function initReviewCarousel() {
    document.querySelectorAll('[data-nw-review-carousel]').forEach(function(carousel) {
      var track = carousel.querySelector('[data-nw-review-track]');
      var dots = carousel.querySelectorAll('[data-nw-review-dot]');
      var prevBtn = carousel.querySelector('[data-nw-review-prev]');
      var nextBtn = carousel.querySelector('[data-nw-review-next]');
      var slides = carousel.querySelectorAll('.nw-reviews__carousel-slide');
      var current = 0;
      var total = slides.length;

      function goTo(idx) {
        current = Math.max(0, Math.min(idx, total - 1));
        if (track) track.style.transform = 'translateX(-' + (current * 100) + '%)';
        dots.forEach(function(d, i) {
          d.classList.toggle('is-active', i === current);
        });
        if (prevBtn) prevBtn.disabled = current === 0;
        if (nextBtn) nextBtn.disabled = current === total - 1;
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });
      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() { goTo(i); });
      });

      goTo(0);
    });
  }

  /* ==================================================================
     REVIEW DATA OVERLAY (420+ JS-driven reviews)
     ================================================================== */
  function shuffleArray(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
    return arr;
  }

  function buildStarsHtml(rating) {
    var s = '';
    for (var i = 0; i < 5; i++) {
      s += '<svg width="12" height="12" viewBox="0 0 24 24" fill="' + (i < rating ? '#F5A623' : '#ddd') + '" stroke="none"><polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"/></svg>';
    }
    return s;
  }

  function renderReviewCard(r) {
    return '<div class="nw-reviews__carousel-slide"><div class="nw-reviews__card">' +
      '<div class="nw-reviews__card-header"><div>' +
      '<div class="nw-reviews__card-name">' + r[0] + '</div>' +
      '<div class="nw-reviews__card-date" style="display:flex;gap:8px;align-items:center;margin-top:4px;">' +
      '<span class="nw-stars">' + buildStarsHtml(r[1]) + '</span><span>' + r[2] + '</span></div>' +
      '</div>' + (r[6] ? '<span class="nw-reviews__verified">&check; Do&#287;rulanm&#305;&#351; Al&#305;c&#305;</span>' : '') +
      '</div>' +
      '<div class="nw-reviews__card-body">' + r[5] + '</div>' +
      '<div class="nw-reviews__card-meta">Beden: ' + r[3] + ' &middot; Boy: ' + r[4] + '</div>' +
      '</div></div>';
  }

  function initReviewDataOverlay() {
    if (typeof NW_REVIEWS_DATA === 'undefined') return;
    var carousel = document.querySelector('[data-nw-review-carousel]');
    if (!carousel) return;

    var reviews = NW_REVIEWS_DATA.slice();
    shuffleArray(reviews);

    var track = carousel.querySelector('[data-nw-review-track]');
    var prevBtn = carousel.querySelector('[data-nw-review-prev]');
    var nextBtn = carousel.querySelector('[data-nw-review-next]');
    var total = reviews.length;
    var current = 0;

    if (track) {
      var html = '';
      for (var i = 0; i < total; i++) html += renderReviewCard(reviews[i]);
      track.innerHTML = html;
    }

    var dotsContainer = carousel.querySelector('.nw-reviews__dots');
    if (dotsContainer) {
      dotsContainer.innerHTML = '<span class="nw-reviews__counter" data-nw-review-counter>1 / ' + total + '</span>';
    }
    var counter = carousel.querySelector('[data-nw-review-counter]');

    function goTo(idx) {
      current = ((idx % total) + total) % total;
      if (track) track.style.transform = 'translateX(-' + (current * 100) + '%)';
      if (counter) counter.textContent = (current + 1) + ' / ' + total;
    }

    var newPrev = prevBtn.cloneNode(true);
    newPrev.disabled = false;
    prevBtn.parentNode.replaceChild(newPrev, prevBtn);
    var newNext = nextBtn.cloneNode(true);
    newNext.disabled = false;
    nextBtn.parentNode.replaceChild(newNext, nextBtn);

    newPrev.addEventListener('click', function() { goTo(current - 1); });
    newNext.addEventListener('click', function() { goTo(current + 1); });

    goTo(0);

    var autoTimer = setInterval(function() { goTo(current + 1); }, 6000);
    carousel.addEventListener('mouseenter', function() { clearInterval(autoTimer); });
    carousel.addEventListener('mouseleave', function() {
      autoTimer = setInterval(function() { goTo(current + 1); }, 6000);
    });
  }

  /* ==================================================================
     VIEWER COUNT SIMULATOR (PDP)
     ================================================================== */
  function initViewerCount() {
    var el = document.querySelector('[data-nw-viewer-count]');
    if (!el) return;
    var count = Math.floor(Math.random() * 18) + 5;
    el.textContent = count;
    setInterval(function() {
      var change = Math.random();
      if (change < 0.3) count = Math.min(35, count + 1);
      else if (change < 0.6) count = Math.max(3, count - 1);
      el.textContent = count;
    }, 3000 + Math.floor(Math.random() * 4000));
  }

  /* ==================================================================
     MOBILE SUBMENU TOGGLE
     ================================================================== */
  function initMobileSubmenus() {
    document.querySelectorAll('[data-nw-submenu-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var item = btn.closest('.nw-mobile-menu__item--has-children');
        if (item) item.classList.toggle('is-open');
      });
    });
  }

  /* ==================================================================
     WISHLIST HEART TOGGLE
     ================================================================== */
  function initWishlistHearts() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.nw-product-card__wishlist, .nw-pdp__wishlist-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      btn.classList.toggle('is-liked');
    });
  }

  /* ==================================================================
     CART DRAWER — Rotating Testimonials
     ================================================================== */
  function initTestimonialRotation() {
    var container = document.querySelector('[data-nw-testimonials]');
    if (!container) return;
    var items = container.querySelectorAll('.nw-cart-drawer__testimonial');
    if (items.length < 2) return;
    if (container._rotateTimer) clearInterval(container._rotateTimer);
    var current = 0;
    items.forEach(function(item, i) {
      item.style.display = i === 0 ? '' : 'none';
      item.style.opacity = i === 0 ? '1' : '0';
    });
    container._rotateTimer = setInterval(function() {
      items[current].style.opacity = '0';
      var prev = current;
      current = (current + 1) % items.length;
      setTimeout(function() {
        items[prev].style.display = 'none';
        items[current].style.display = '';
        requestAnimationFrame(function() {
          items[current].style.opacity = '1';
        });
      }, 300);
    }, 4000);
  }

  /* ==================================================================
     COLLECTION — Filter Toggle + Sort
     ================================================================== */
  function initCollectionTools() {
    var filterToggle = document.querySelector('[data-nw-filter-toggle]');
    var filterPanel = document.querySelector('[data-nw-filter-panel]');
    if (filterToggle && filterPanel) {
      filterToggle.addEventListener('click', function() {
        filterPanel.classList.toggle('is-open');
      });
    }

    var sortSelect = document.querySelector('[data-nw-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }
  }

  /* ==================================================================
     INIT ALL
     ================================================================== */
  /* ==================================================================
     AKAN TICKER — Photos + Reviews flowing
     ================================================================== */
  function initReviewTicker() {
    var ticker = document.querySelector('[data-nw-ticker]');
    if (!ticker) return;
    var track = ticker.querySelector('[data-nw-ticker-track]');
    if (!track) return;

    var reviews = (typeof NW_REVIEWS_DATA !== 'undefined') ? NW_REVIEWS_DATA : [];
    if (reviews.length === 0) return;

    var shuffled = reviews.slice();
    for (var i = shuffled.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = shuffled[i]; shuffled[i] = shuffled[j]; shuffled[j] = tmp;
    }

    function tickerStars(rating) {
      var s = '';
      for (var k = 0; k < 5; k++) {
        s += '<svg width="10" height="10" viewBox="0 0 24 24" fill="' + (k < rating ? '#F5A623' : '#ddd') + '" stroke="none"><polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"/></svg>';
      }
      return s;
    }

    var sizeVariants = ['', ' nw-ticker__item--photo-tall', ' nw-ticker__item--photo-wide'];
    var reviewVariants = ['', ' nw-ticker__item--review-compact'];

    function buildTickerReview(r, compact) {
      var name = r[0], rating = r[1], date = r[2], size = r[3], height = r[4], body = r[5], verified = r[6];
      var cls = compact ? 'nw-ticker__item nw-ticker__item--review nw-ticker__item--review-compact' : 'nw-ticker__item nw-ticker__item--review';
      var html = '<div class="' + cls + '">';
      html += '<div class="nw-ticker__review-top"><span class="nw-ticker__review-name">' + name + '</span>';
      if (verified) html += '<span class="nw-ticker__review-verified">&#10003; Do&#287;rulanm&#305;&#351; Al&#305;c&#305;</span>';
      html += '</div>';
      html += '<div class="nw-ticker__review-stars">' + tickerStars(rating) + '</div>';
      html += '<div class="nw-ticker__review-body">' + body + '</div>';
      html += '<div class="nw-ticker__review-meta">' + size + ' &middot; ' + height + ' &middot; ' + date + '</div>';
      html += '</div>';
      return html;
    }

    var photoItems = track.querySelectorAll('.nw-ticker__item--photo');
    var row1 = [];
    var row2 = [];
    var ri = 0;
    var useRow1 = true;

    for (var p = 0; p < photoItems.length; p++) {
      var photoHtml = photoItems[p].outerHTML;
      var variant = sizeVariants[Math.floor(Math.random() * sizeVariants.length)];
      if (variant) {
        photoHtml = photoHtml.replace('nw-ticker__item--photo', 'nw-ticker__item--photo' + variant);
      }
      if (useRow1) { row1.push(photoHtml); } else { row2.push(photoHtml); }
      useRow1 = !useRow1;

      var reviewCount = 1 + Math.floor(Math.random() * 2);
      for (var rc = 0; rc < reviewCount; rc++) {
        if (ri < shuffled.length) {
          var compact = Math.random() > 0.5;
          var rev = buildTickerReview(shuffled[ri], compact);
          if (useRow1) { row1.push(rev); } else { row2.push(rev); }
          useRow1 = !useRow1;
          ri++;
        }
      }
    }

    while (ri < Math.min(shuffled.length, 40)) {
      var compact = Math.random() > 0.5;
      var rev = buildTickerReview(shuffled[ri], compact);
      if (ri % 2 === 0) { row1.push(rev); } else { row2.push(rev); }
      ri++;
    }

    var set1 = row1.join('');
    var set2 = row2.join('');
    track.innerHTML = set1 + set1;

    var track2 = document.createElement('div');
    track2.className = 'nw-ticker__track nw-ticker__track--row2';
    track2.innerHTML = set2 + set2;
    track.parentNode.appendChild(track2);

    var viewport = ticker.querySelector('.nw-ticker__viewport');
    if (viewport && 'ontouchstart' in window) {
      viewport.addEventListener('click', function() {
        viewport.classList.toggle('is-paused');
      });
    }
  }

  function init() {
    initCountdown();
    initSearchToggle();
    initMobileMenu();
    initMobileSubmenus();
    initCartDrawer();
    initAjaxCart();
    initBuyNow();
    initAccordions();
    initGallery();
    initQuantity();
    initSizeSelector();
    initReviewCarousel();
    initReviewDataOverlay();
    initViewerCount();
    initCollectionTools();
    initWishlistHearts();
    initTestimonialRotation();
    initReviewTicker();
    initFooterAccordion();
  }

  function initFooterAccordion() {
    var toggles = document.querySelectorAll('[data-nw-footer-toggle]');
    for (var i = 0; i < toggles.length; i++) {
      toggles[i].addEventListener('click', function() {
        var col = this.parentElement;
        if (!col) return;
        var wasOpen = col.classList.contains('is-open');
        var allCols = col.parentElement.querySelectorAll('.nw-footer__col');
        for (var j = 0; j < allCols.length; j++) { allCols[j].classList.remove('is-open'); }
        if (!wasOpen) col.classList.add('is-open');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* ==================================================================
     NAVRA EKLER — Popup'lar, Beden Rehberi, Hızlı Ekle, Yorum Yaz,
     Puana tıklayınca yorumlara kaydırma
     ================================================================== */
  var NW_CLOSE_ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  function nwEsc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function nwOpenModal(modal) {
    if (!modal) return;
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    modal._nwLastFocus = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var panel = modal.querySelector('.nw-modal__panel');
    if (panel) {
      panel.setAttribute('tabindex', '-1');
      panel.focus({ preventScroll: true });
    }
  }

  function nwCloseModal(modal) {
    if (!modal || !modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (modal._nwLastFocus && modal._nwLastFocus.focus) modal._nwLastFocus.focus({ preventScroll: true });
  }

  function initNwModals() {
    document.addEventListener('click', function(e) {
      var closer = e.target.closest('[data-nw-modal-close]');
      if (!closer) return;
      e.preventDefault();
      nwCloseModal(closer.closest('.nw-modal'));
    });
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.nw-modal.is-open').forEach(nwCloseModal);
    });
  }

  /* ---------- Puana (yıldızlara) tıklayınca yorumlara kaydır ---------- */
  function initRatingScroll() {
    var rating = document.querySelector('.nw-pdp__rating');
    if (!rating) return;
    rating.setAttribute('role', 'link');
    rating.setAttribute('tabindex', '0');
    rating.setAttribute('title', 'Yorumları gör');

    function go(e) {
      var target = document.querySelector('.nw-ticker__heading') || document.querySelector('.nw-ticker') || document.querySelector('.nw-reviews');
      if (!target) return;
      e.preventDefault();
      var header = document.querySelector('.nw-sticky-header-group');
      var isSticky = header && /sticky|fixed/.test(window.getComputedStyle(header).position);
      var offset = (isSticky ? header.offsetHeight : 0) + 16;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    rating.addEventListener('click', go);
    rating.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') go(e);
    });
  }

  /* ---------- Beden Rehberi ---------- */
  var NW_SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];

  function nwNormSize(s) {
    s = String(s || '').toUpperCase().replace(/\s+/g, '');
    if (s === 'XXL') return '2XL';
    if (s === 'XXXL') return '3XL';
    if (s === 'XXXXL') return '4XL';
    return s;
  }

  function nwRecommendSize(height, weight, available) {
    // Kiloya göre temel beden (NW_SIZE_ORDER içinde 1 = XS ... 7 = 3XL), boya göre ±1
    var idx = weight < 55 ? 1 : weight < 65 ? 2 : weight < 75 ? 3 : weight < 85 ? 4 : weight < 95 ? 5 : weight < 105 ? 6 : 7;
    if (height >= 188) idx++;
    else if (height < 160) idx--;
    idx = Math.max(0, Math.min(NW_SIZE_ORDER.length - 1, idx));
    if (!available.length) return NW_SIZE_ORDER[idx];

    var best = null;
    var bestDiff = Infinity;
    available.forEach(function(label) {
      var i = NW_SIZE_ORDER.indexOf(nwNormSize(label));
      if (i === -1) return;
      var diff = Math.abs(i - idx);
      if (diff < bestDiff) { bestDiff = diff; best = label; }
    });
    if (best) return best;

    // Harf olmayan bedenler (örn. 28, 30, 32...) için orantılı seçim
    var pos = Math.round((idx - 1) / 6 * (available.length - 1));
    return available[Math.max(0, Math.min(available.length - 1, pos))];
  }

  // Beden rehberindeki "Boy ve kiloya göre beden" tablosundan en uygun bedeni seçer
  function nwRange(text) {
    var m = String(text || '').match(/(\d+(?:[.,]\d+)?)\s*[-–]\s*(\d+(?:[.,]\d+)?)/);
    return m ? [parseFloat(m[1].replace(',', '.')), parseFloat(m[2].replace(',', '.'))] : null;
  }

  function nwFitSize(modal, height, weight) {
    var best = null;
    var bestScore = Infinity;
    modal.querySelectorAll('[data-nw-fit-row]').forEach(function(row) {
      var hr = nwRange(row.getAttribute('data-h'));
      var wr = nwRange(row.getAttribute('data-w'));
      if (!hr || !wr) return;
      var dh = height < hr[0] ? hr[0] - height : height > hr[1] ? height - hr[1] : 0;
      var dw = weight < wr[0] ? wr[0] - weight : weight > wr[1] ? weight - wr[1] : 0;
      // Aralık dışında kalan kilo, boydan daha önemli; ikisi de uyuyorsa ortaya en yakın beden
      var near = Math.abs(weight - (wr[0] + wr[1]) / 2) / Math.max(1, wr[1] - wr[0]) +
        0.5 * Math.abs(height - (hr[0] + hr[1]) / 2) / Math.max(1, hr[1] - hr[0]);
      var score = (dw + 0.5 * dh) * 10 + near;
      if (score < bestScore) { bestScore = score; best = row.getAttribute('data-size'); }
    });
    return best;
  }

  function nwFindPdpChip(size) {
    var wanted = nwNormSize(size);
    var chips = document.querySelectorAll('.nw-pdp [data-nw-option-value]');
    for (var i = 0; i < chips.length; i++) {
      if (nwNormSize(chips[i].getAttribute('data-nw-option-value')) === wanted) return chips[i];
    }
    return null;
  }

  function initSizeGuide() {
    var modal = document.querySelector('[data-nw-modal="size-guide"]');
    if (!modal) return;
    document.body.appendChild(modal);

    document.addEventListener('click', function(e) {
      if (!e.target.closest('[data-nw-size-guide-open]')) return;
      e.preventDefault();
      nwOpenModal(modal);
    });

    // Sekmeler
    var tabs = modal.querySelectorAll('[data-nw-sg-tab]');
    var panes = modal.querySelectorAll('[data-nw-sg-pane]');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var name = tab.getAttribute('data-nw-sg-tab');
        tabs.forEach(function(t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panes.forEach(function(p) {
          p.classList.toggle('is-active', p.getAttribute('data-nw-sg-pane') === name);
        });
      });
    });

    // CM / İNÇ
    var units = modal.querySelectorAll('[data-nw-sg-unit]');
    units.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var inch = btn.getAttribute('data-nw-sg-unit') === 'in';
        units.forEach(function(u) { u.classList.toggle('is-active', u === btn); });
        modal.querySelectorAll('[data-nw-sg-unit-label]').forEach(function(l) {
          l.textContent = inch ? 'İNÇ' : 'CM';
        });
        modal.querySelectorAll('[data-nw-sg-cm]').forEach(function(td) {
          var cm = td.getAttribute('data-nw-sg-cm');
          td.textContent = !inch ? cm : cm.replace(/\d+(?:[.,]\d+)?/g, function(n) {
            return String(Math.round(parseFloat(n.replace(',', '.')) / 2.54 * 10) / 10);
          });
        });
      });
    });

    // Bedenini bul
    var hIn = modal.querySelector('[data-nw-sg-height]');
    var wIn = modal.querySelector('[data-nw-sg-weight]');
    var findBtn = modal.querySelector('[data-nw-sg-find]');
    var result = modal.querySelector('[data-nw-sg-result]');
    if (!hIn || !wIn || !findBtn || !result) return;

    var sizes = [];
    modal.querySelectorAll('[data-nw-sg-size]').forEach(function(td) { sizes.push(td.textContent.trim()); });

    function find() {
      var h = parseFloat(hIn.value);
      var w = parseFloat(wIn.value);
      result.classList.add('is-visible');
      if (!(h >= 140 && h <= 220) || !(w >= 35 && w <= 200)) {
        result.innerHTML = '<div class="nw-sg__result-error">Lütfen geçerli bir boy (140–220 cm) ve kilo (35–200 kg) gir.</div>';
        return;
      }
      var size = nwFitSize(modal, h, w) || nwRecommendSize(h, w, sizes);
      var chip = nwFindPdpChip(size);
      result.innerHTML =
        '<div class="nw-sg__result-label">SANA ÖNERİLEN BEDEN</div>' +
        '<div class="nw-sg__result-size">' + nwEsc(size) + '</div>' +
        (chip && !chip.classList.contains('is-soldout')
          ? '<button type="button" class="nw-sg__result-btn" data-nw-sg-select="' + nwEsc(size) + '">' + nwEsc(size) + ' BEDENİ SEÇ</button>'
          : '');
    }

    findBtn.addEventListener('click', find);
    [hIn, wIn].forEach(function(input) {
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); find(); }
      });
    });

    result.addEventListener('click', function(e) {
      var sel = e.target.closest('[data-nw-sg-select]');
      if (!sel) return;
      var chip = nwFindPdpChip(sel.getAttribute('data-nw-sg-select'));
      if (chip) chip.click();
      nwCloseModal(modal);
      showToast(sel.getAttribute('data-nw-sg-select') + ' beden seçildi');
    });
  }

  /* ---------- Yorum Yaz popup'ı ---------- */
  function initReviewForm() {
    var modal = document.querySelector('[data-nw-modal="review-form"]');
    if (!modal) return;
    document.body.appendChild(modal);

    document.addEventListener('click', function(e) {
      if (!e.target.closest('[data-nw-review-open]')) return;
      e.preventDefault();
      nwOpenModal(modal);
    });

    var stars = modal.querySelectorAll('[data-nw-rf-star]');
    var ratingInput = modal.querySelector('[data-nw-rf-rating]');
    var starsWrap = modal.querySelector('[data-nw-rf-stars]');

    function paint(n) {
      stars.forEach(function(s) {
        s.classList.toggle('is-on', parseInt(s.getAttribute('data-nw-rf-star'), 10) <= n);
      });
    }

    stars.forEach(function(star) {
      var n = parseInt(star.getAttribute('data-nw-rf-star'), 10);
      star.addEventListener('click', function() {
        if (ratingInput) ratingInput.value = n;
        stars.forEach(function(s) { s.setAttribute('aria-checked', s === star ? 'true' : 'false'); });
        paint(n);
      });
      star.addEventListener('mouseenter', function() { paint(n); });
    });
    if (starsWrap) {
      starsWrap.addEventListener('mouseleave', function() {
        paint(parseInt(ratingInput ? ratingInput.value : 5, 10) || 5);
      });
    }

    var form = modal.querySelector('form');
    var submit = modal.querySelector('[data-nw-rf-submit]');
    if (form && submit) {
      form.addEventListener('submit', function() {
        submit.disabled = true;
        submit.textContent = 'Gönderiliyor...';
      });
    }

    // Gönderimden sonra sayfa yenilenince: popup'ı aç, sonucu göster
    if (modal.querySelector('[data-nw-review-posted], [data-nw-review-error]')) {
      var reviews = document.querySelector('.nw-reviews');
      if (reviews) reviews.scrollIntoView();
      nwOpenModal(modal);
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.delete('contact_posted');
        url.hash = '';
        history.replaceState(null, '', url.toString());
      }
    }
  }

  /* ---------- Hızlı Ekle (koleksiyon kartları, PC) ---------- */
  function nwImg(src, width) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  // Fiyatı, kartta görünen fiyatla aynı biçimde yazar (ör. "699.90TL")
  function nwMoneyFormatter(sample) {
    var m = sample ? sample.match(/\d[\d.,'\s ]*\d|\d/) : null;
    if (!m) return function(c) { return (c / 100).toFixed(2) + 'TL'; };
    var num = m[0];
    var prefix = sample.slice(0, m.index);
    var suffix = sample.slice(m.index + num.length);
    var decimals = /[.,]\d{2}$/.test(num) ? 2 : 0;
    var seps = num.replace(/\d/g, '');
    var decSep = decimals ? num.charAt(num.length - 3) : '.';
    var thouSep = decimals
      ? (seps.length > 1 ? seps.charAt(0) : (decSep === ',' ? '.' : ','))
      : (seps.length ? seps.charAt(0) : ',');
    return function(cents) {
      var parts = (cents / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
      return prefix + parts.join(decSep) + suffix;
    };
  }

  function nwSameImage(a, b) {
    var clean = function(u) { return String(u || '').split('?')[0].replace(/^https?:/, ''); };
    return clean(a) === clean(b);
  }

  var nwQuickView = null;

  function nwGetQuickView() {
    if (nwQuickView) return nwQuickView;
    nwQuickView = document.createElement('div');
    nwQuickView.className = 'nw-modal nw-qv';
    nwQuickView.setAttribute('data-nw-modal', 'quick-view');
    nwQuickView.setAttribute('aria-hidden', 'true');
    nwQuickView.innerHTML =
      '<div class="nw-modal__scrim" data-nw-modal-close></div>' +
      '<div class="nw-modal__panel nw-qv__panel" role="dialog" aria-modal="true" aria-label="Hızlı ekle">' +
        '<button type="button" class="nw-modal__close nw-qv__close" data-nw-modal-close aria-label="Kapat">' + NW_CLOSE_ICON + '</button>' +
        '<div class="nw-qv__body" data-nw-qv-body></div>' +
      '</div>';
    document.body.appendChild(nwQuickView);
    return nwQuickView;
  }

  function nwOpenQuickView(href, card) {
    var modal = nwGetQuickView();
    var body = modal.querySelector('[data-nw-qv-body]');
    var url = new URL(href, window.location.origin);
    var match = url.pathname.match(/\/products\/([^\/?#]+)/);
    if (!match) { window.location.href = href; return; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    body.innerHTML = '<div class="nw-qv__loading"><span class="nw-qv__spinner"></span></div>';
    nwOpenModal(modal);

    fetch(root + 'products/' + match[1] + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { if (!r.ok) throw new Error('product'); return r.json(); })
      .then(function(product) {
        var priceEl = card ? card.querySelector('.nw-product-card__price') : null;
        nwRenderQuickView(modal, body, product, url.pathname, nwMoneyFormatter(priceEl ? priceEl.textContent.trim() : ''));
      })
      .catch(function() { window.location.href = href; });
  }

  function nwRenderQuickView(modal, body, p, productUrl, money) {
    var variants = p.variants || [];
    if (!variants.length) { window.location.href = productUrl; return; }

    var options = (p.options || []).map(function(o, i) {
      if (typeof o === 'string') {
        var vals = [];
        variants.forEach(function(v) {
          var x = v.options[i];
          if (vals.indexOf(x) === -1) vals.push(x);
        });
        return { name: o, values: vals };
      }
      return { name: o.name, values: o.values || [] };
    });
    var isDefaultOnly = variants.length === 1 && (!options.length || (options.length === 1 && options[0].values[0] === 'Default Title'));

    var current = variants[0];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) { current = variants[i]; break; }
    }
    var selected = (current.options || []).slice();

    function variantImage(v) {
      return v && v.featured_image && v.featured_image.src ? v.featured_image.src : null;
    }

    var images = (p.images || []).slice(0, 8);
    var mainSrc = variantImage(current) || p.featured_image || images[0] || '';

    var html = '<div class="nw-qv__grid">';
    html += '<div class="nw-qv__media">';
    html += '<div class="nw-qv__main">' + (mainSrc ? '<img data-nw-qv-img src="' + nwEsc(nwImg(mainSrc, 800)) + '" alt="' + nwEsc(p.title) + '" width="600" height="800">' : '') + '</div>';
    if (images.length > 1) {
      html += '<div class="nw-qv__thumbs">';
      images.forEach(function(src, idx) {
        html += '<button type="button" class="nw-qv__thumb' + (idx === 0 ? ' is-active' : '') + '" data-nw-qv-thumb="' + nwEsc(src) + '" aria-label="Görsel ' + (idx + 1) + '">' +
          '<img src="' + nwEsc(nwImg(src, 120)) + '" alt="" width="54" height="72" loading="lazy"></button>';
      });
      html += '</div>';
    }
    html += '</div>';

    html += '<div class="nw-qv__info">';
    html += '<div class="nw-qv__eyebrow">HIZLI EKLE</div>';
    html += '<h2 class="nw-qv__title">' + nwEsc(p.title) + '</h2>';
    html += '<div class="nw-qv__prices"><span class="nw-qv__price" data-nw-qv-price></span><span class="nw-qv__compare" data-nw-qv-compare></span><span class="nw-qv__badge" data-nw-qv-badge></span></div>';

    if (!isDefaultOnly) {
      options.forEach(function(opt, oi) {
        var lower = String(opt.name).toLowerCase();
        var isColor = lower === 'renk' || lower === 'color' || lower === 'colour';
        html += '<div class="nw-pdp__option nw-qv__option" data-nw-qv-option="' + oi + '">';
        html += '<div class="nw-pdp__option-label"><span>' + nwEsc(opt.name) + ': <strong data-nw-qv-selected>' + nwEsc(selected[oi]) + '</strong></span></div>';
        html += '<div class="' + (isColor ? 'nw-pdp__color-swatches' : 'nw-pdp__sizes') + '">';
        opt.values.forEach(function(val) {
          var active = selected[oi] === val ? ' is-active' : '';
          var img = null;
          if (isColor) {
            for (var k = 0; k < variants.length; k++) {
              if (variants[k].options[oi] === val && variantImage(variants[k])) { img = variantImage(variants[k]); break; }
            }
          }
          if (img) {
            html += '<button type="button" class="nw-pdp__color-swatch nw-qv__swatch' + active + '" title="' + nwEsc(val) + '" data-nw-qv-value="' + nwEsc(val) + '">' +
              '<img src="' + nwEsc(nwImg(img, 80)) + '" alt="' + nwEsc(val) + '" width="46" height="46"></button>';
          } else {
            html += '<button type="button" class="nw-pdp__size-chip' + active + '" data-nw-qv-value="' + nwEsc(val) + '">' + nwEsc(val) + '</button>';
          }
        });
        html += '</div></div>';
      });
    }

    html += '<div class="nw-qv__qty-row"><div class="nw-pdp__option-label" style="margin-bottom:0;">Adet</div>' +
      '<div class="nw-pdp__qty"><button type="button" class="nw-pdp__qty-btn" data-nw-qv-minus aria-label="Azalt">&minus;</button>' +
      '<input type="number" value="1" min="1" class="nw-pdp__qty-input" data-nw-qv-qty aria-label="Adet">' +
      '<button type="button" class="nw-pdp__qty-btn" data-nw-qv-plus aria-label="Arttır">+</button></div></div>';
    html += '<button type="button" class="nw-btn nw-btn--full" data-nw-qv-add></button>';
    html += '<div class="nw-qv__error" data-nw-qv-error></div>';
    html += '<a class="nw-qv__details" href="' + nwEsc(productUrl) + '">Ürün detaylarını gör &rarr;</a>';
    html += '</div></div>';

    body.innerHTML = html;

    var imgEl = body.querySelector('[data-nw-qv-img]');
    var priceEl = body.querySelector('[data-nw-qv-price]');
    var compareEl = body.querySelector('[data-nw-qv-compare]');
    var badgeEl = body.querySelector('[data-nw-qv-badge]');
    var addBtn = body.querySelector('[data-nw-qv-add]');
    var qtyInput = body.querySelector('[data-nw-qv-qty]');
    var errorEl = body.querySelector('[data-nw-qv-error]');
    var groups = body.querySelectorAll('[data-nw-qv-option]');

    function findVariant(vals) {
      for (var a = 0; a < variants.length; a++) {
        var ok = true;
        for (var b = 0; b < vals.length; b++) {
          if (variants[a].options[b] !== vals[b]) { ok = false; break; }
        }
        if (ok) return variants[a];
      }
      return null;
    }

    function setImage(src) {
      if (!src || !imgEl) return;
      imgEl.src = nwImg(src, 800);
      body.querySelectorAll('[data-nw-qv-thumb]').forEach(function(t) {
        t.classList.toggle('is-active', nwSameImage(t.getAttribute('data-nw-qv-thumb'), src));
      });
    }

    function markSoldOut() {
      groups.forEach(function(group, gi) {
        group.querySelectorAll('[data-nw-qv-value]').forEach(function(chip) {
          var test = selected.slice();
          test[gi] = chip.getAttribute('data-nw-qv-value');
          var v = findVariant(test);
          chip.classList.toggle('is-soldout', !(v && v.available));
        });
      });
    }

    function apply() {
      current = findVariant(selected);
      errorEl.textContent = '';
      if (!current) {
        addBtn.disabled = true;
        addBtn.textContent = 'Bu seçenek mevcut değil';
        return;
      }
      priceEl.textContent = money(current.price);
      var hasCompare = current.compare_at_price && current.compare_at_price > current.price;
      compareEl.textContent = hasCompare ? money(current.compare_at_price) : '';
      compareEl.style.display = hasCompare ? '' : 'none';
      badgeEl.style.display = hasCompare ? '' : 'none';
      if (hasCompare) badgeEl.textContent = '%' + Math.round((current.compare_at_price - current.price) * 100 / current.compare_at_price) + ' İNDİRİM';
      addBtn.disabled = !current.available;
      addBtn.textContent = current.available ? 'Sepete Ekle · ' + money(current.price) : 'Tükendi';
      if (variantImage(current)) setImage(variantImage(current));
      markSoldOut();
    }

    groups.forEach(function(group) {
      var oi = parseInt(group.getAttribute('data-nw-qv-option'), 10);
      group.querySelectorAll('[data-nw-qv-value]').forEach(function(chip) {
        chip.addEventListener('click', function() {
          group.querySelectorAll('[data-nw-qv-value]').forEach(function(c) { c.classList.remove('is-active'); });
          chip.classList.add('is-active');
          selected[oi] = chip.getAttribute('data-nw-qv-value');
          var label = group.querySelector('[data-nw-qv-selected]');
          if (label) label.textContent = selected[oi];
          apply();
        });
      });
    });

    body.querySelectorAll('[data-nw-qv-thumb]').forEach(function(t) {
      t.addEventListener('click', function() { setImage(t.getAttribute('data-nw-qv-thumb')); });
    });

    body.querySelector('[data-nw-qv-minus]').addEventListener('click', function() {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    });
    body.querySelector('[data-nw-qv-plus]').addEventListener('click', function() {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
    });

    addBtn.addEventListener('click', function() {
      if (!current || !current.available) return;
      var label = addBtn.textContent;
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      addBtn.disabled = true;
      addBtn.textContent = 'Ekleniyor...';
      errorEl.textContent = '';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: current.id, quantity: qty }] })
      })
        .then(function(r) {
          return r.json().then(function(data) { if (!r.ok) throw data; return data; });
        })
        .then(function() {
          nwCloseModal(modal);
          showToast('Sepete eklendi · ' + p.title.split(' ').slice(-3).join(' '));
          return fetch(root + 'cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              updateCartCount(cart.item_count);
              refreshCartDrawer();
              openCartDrawer();
            });
        })
        .catch(function(err) {
          addBtn.disabled = false;
          addBtn.textContent = label;
          errorEl.textContent = (err && err.description) || 'Sepete eklenemedi. Lütfen tekrar deneyin.';
        });
    });

    apply();
  }

  function initQuickAdd() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.nw-product-card__quick-add');
      if (!btn) return;
      var card = btn.closest('.nw-product-card');
      var href = card ? card.getAttribute('href') : null;
      if (!href) return;
      e.preventDefault();
      e.stopPropagation();
      nwOpenQuickView(href, card);
    });
  }

  function initNavraExtras() {
    initNwModals();
    initRatingScroll();
    initSizeGuide();
    initReviewForm();
    initQuickAdd();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavraExtras);
  } else {
    initNavraExtras();
  }
})();
